import { ThemeSet } from "../../types";
import { generateThemeFromPalette } from "../../utils";
import { premiumPalette } from "../palette/premiumPalette";

const premiumLightTheme = generateThemeFromPalette(premiumPalette, "light");
const premiumDarkTheme = generateThemeFromPalette(premiumPalette, "dark");

export const premium: ThemeSet = {
  light: {
    ...premiumLightTheme
  },
  dark: {
    ...premiumDarkTheme
  }
};
